/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Feedback_Modal_Loading_Create_DescInputs */

const es_feedback_modal_loading_create_desc = /** @type {(inputs: Feedback_Modal_Loading_Create_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procesando tu solicitud.`)
};

const en_feedback_modal_loading_create_desc = /** @type {(inputs: Feedback_Modal_Loading_Create_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Processing your request.`)
};

/**
* | output |
* | --- |
* | "Processing your request." |
*
* @param {Feedback_Modal_Loading_Create_DescInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const feedback_modal_loading_create_desc = /** @type {((inputs?: Feedback_Modal_Loading_Create_DescInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Feedback_Modal_Loading_Create_DescInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_feedback_modal_loading_create_desc(inputs)
	return en_feedback_modal_loading_create_desc(inputs)
});
export { feedback_modal_loading_create_desc as "feedback.modal.loading_create_desc" }